module.exports = __webpack_public_path__ + "static/media/MERNMultiStepForm.49d428bd.png";